import { CSSProperties } from 'react';
import { MAIN_THEME } from 'styles/colors';

export const selectComponentStyles = {
	container: (containerStyles: CSSProperties) => ({
		...containerStyles,
		width: '100%',
		height: 44,
		paddingLeft: 8,
		paddingRight: 8,
	}),
	control: (selectStyles: CSSProperties, { isFocused }: any) => ({
		...selectStyles,
		background: 'rgba(11, 19, 38, 0.95)',
		border: isFocused
			? '1px solid rgba(148, 163, 184, 0.5)'
			: '1px solid rgba(148, 163, 184, 0.25)',
		boxShadow: isFocused ? '0 0 0 3px rgba(148, 163, 184, 0.2)' : 'none',
		borderRadius: 12,
		padding: '0 8px',
		outline: 'none',
		height: '100%',
		cursor: 'pointer',
	}),
	input: (inputStyles: CSSProperties) => ({
		...inputStyles,
		border: 'none',
		padding: '5px 0',
		color: MAIN_THEME.TEXT_PRIMARY,
	}),
	singleValue: (singleValueStyles: CSSProperties) => ({
		...singleValueStyles,
		color: MAIN_THEME.TEXT_PRIMARY,
		fontWeight: 600,
	}),
	placeholder: (placeholderStyles: CSSProperties) => ({
		...placeholderStyles,
		color: MAIN_THEME.TEXT_TERTIARY,
		fontWeight: 500,
		letterSpacing: '0.2px',
	}),
	menu: (menuStyles: CSSProperties) => ({
		...menuStyles,
		width: '100%',
		left: 0,
		backgroundColor: 'rgba(11, 19, 38, 0.98)',
		border: '1px solid rgba(148, 163, 184, 0.25)',
		borderRadius: 12,
		boxShadow: '0 16px 34px rgba(0, 0, 0, 0.35)',
		zIndex: 10,
		marginTop: 8,
	}),
	menuList: (menuListStyles: CSSProperties) => ({
		...menuListStyles,
		padding: 8,
	}),
	option: (optionStyles: CSSProperties, { isFocused, isSelected }: any) => ({
		...optionStyles,
		backgroundColor: isSelected
			? 'rgba(148, 163, 184, 0.25)'
			: isFocused
				? 'rgba(148, 163, 184, 0.18)'
				: 'transparent',
		color: MAIN_THEME.TEXT_PRIMARY,
		cursor: 'pointer',
		padding: '10px 12px',
		borderRadius: 8,
	}),
	indicatorSeparator: () => ({ display: 'none' }),
	dropdownIndicator: (indicatorStyles: CSSProperties) => ({
		...indicatorStyles,
		color: MAIN_THEME.TEXT_TERTIARY,
		padding: 0,
	}),
	clearIndicator: (indicatorStyles: CSSProperties) => ({
		...indicatorStyles,
		color: MAIN_THEME.TEXT_TERTIARY,
		padding: 0,
	}),
} as any;
